import { useEffect, useState } from "react";
import { ICategoryLiteAsset } from "models/Assets/ICategoryAsset";
import { useGetRoutesObjects } from "contexts/RoutesObjectContext";

export const SUBCATEGORY_CHANGE_EVENT_NAME = "on-change-subCategory";
export const useGetSubCategory = () :ICategoryLiteAsset => {
  const { subCategory: _default } = useGetRoutesObjects();
  const [subCategory, setSubCategory] = useState<ICategoryLiteAsset>(_default);
  useEffect(() => {
    const onSuccess = (e) => setSubCategory(e.detail.subCategoryUpdated);
    document.addEventListener(SUBCATEGORY_CHANGE_EVENT_NAME, onSuccess);
    return () =>
      document.removeEventListener(SUBCATEGORY_CHANGE_EVENT_NAME, onSuccess);
  }, []);

  return subCategory
};
